export var production = {
    enviroment: "production",
    firebase: {
        apiKey: "AIzaSyDJfIdZ0zBXHWU31GvKykyotoczy6NyYTo",
        // authDomain: "blast-7ed0b.firebaseapp.com",
        authDomain: "wchsblast.com",
        databaseURL: "https://blast-7ed0b.firebaseio.com",
        projectId: "blast-7ed0b",
        storageBucket: "blast-7ed0b.appspot.com",
        messagingSenderId: "308619667588",
        appId: "1:308619667588:web:4b25c59426b445f1ba7ad1",
        measurementId: "G-1RZPVXG9V0"
    }
};

//# sourceMappingURL=production.js.map